import {
  Component,
  AfterViewInit,
  ElementRef,
  ViewChild,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import Quill from 'quill';
import type { Delta } from 'quill/core';

@Component({
  selector: 'app-quill-readonly',
  imports: [],
  templateUrl: './quill-readonly.component.html',
  styleUrl: './quill-readonly.component.scss',
})
export class QuillReadonlyComponent implements AfterViewInit, OnChanges {
  @Input() content!: Delta | undefined;

  @ViewChild('editor', { static: false }) editorElement!: ElementRef;
  private quill: Quill | undefined;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['content'] && this.quill && this.content) {
      this.quill.setContents(this.content);
    }
  }

  ngAfterViewInit(): void {
    this.quill = new Quill(this.editorElement.nativeElement, {
      theme: 'snow',
      readOnly: true,
      modules: {
        toolbar: false,
      },
    });

    if (this.content) {
      this.quill.setContents(this.content);
    }
  }
}
